import { useQuery } from '@apollo/client';
import {
  GET_QUALITATIVE_FACTOR_WORKAROUND_STATS,
  GET_QUALITATIVE_FACTOR_WORKAROUNDS,
} from '../queries';

/**
 * Hook to get qualitative factor workarounds stats
 * @param locationUUID - The location UUID
 * @returns An object containing the stats, loading, and error
 */
export const useQualitativeFactorWorkaroundStats = (
  locationUUID: string | undefined,
) => {
  const {
    data: statsData,
    loading: statsLoading,
    error: statsError,
  } = useQuery(GET_QUALITATIVE_FACTOR_WORKAROUND_STATS, {
    variables: { locationUUID },
  });

  return {
    stats: statsData?.getQualitativeFactorWorkaroundStats,
    statsLoading,
    statsError,
  };
};

/**
 * Hook to get qualitative factor workarounds
 * @param qualitativeFactorIds - The qualitative factor IDs
 * @param locationUUID - The location UUID
 * @returns An object containing the workarounds, loading, and error
 */
export const useQualitativeFactorWorkarounds = (
  qualitativeFactorIds: string[],
  locationUUID?: string,
) => {
  const { data, loading, error } = useQuery(
    GET_QUALITATIVE_FACTOR_WORKAROUNDS,
    {
      variables: {
        data: {
          uuids: qualitativeFactorIds,
          ...(locationUUID && { locationUuid: locationUUID }),
        },
      },
    },
  );

  return {
    data: data?.getQualitativeFactorWorkarounds,
    loading,
    error,
  };
};
